import { HelpCircle } from 'lucide-react';
import type { ReactNode } from 'react';

export interface PageHeaderProps {
  /**
   * **Không còn dùng.** Breadcrumb nay ở thanh trên (`layout/ThanhTren`), dựng
   * từ menu nên trang không phải khai lại. Prop giữ lại để ~12 trang đang
   * truyền nó không phải sửa cùng một lượt; giá trị bị bỏ qua.
   *
   * @deprecated Bỏ khi chuyển trang sang khung mới (bước 2–3).
   */
  breadcrumb?: string[];
  title: string;
  /** Một dòng phụ **ngắn**. Dài hơn một dòng thì đưa vào `giaiThich`. */
  phu?: string;
  /**
   * **Không còn dùng** như trước: nhận nguyên văn mô tả dài của bản cũ rồi hiện
   * bằng `title` của icon (?) thay vì chiếm ba dòng đầu trang.
   *
   * @deprecated Dùng `phu` cho một dòng, `giaiThich` cho đoạn dài.
   */
  description?: string;
  /** Đoạn giải thích dài, hiện trong tooltip của icon (?) cạnh tiêu đề. */
  giaiThich?: string;
  /** Nút hành động bên phải. Tối đa **một** nút primary. */
  actions?: ReactNode;
}

/**
 * Đầu trang: tiêu đề + một dòng phụ + nút hành động.
 *
 * Bản cũ in cả một đoạn mô tả 2–4 dòng ở mọi trang, nên hơn 100px đầu màn hình
 * là chữ không ai đọc lần thứ hai. Nay: **một dòng**, phần giải thích dài nằm
 * sau icon (?) — ai cần thì trỏ vào.
 */
export function PageHeader({ title, phu, description, giaiThich, actions }: PageHeaderProps) {
  /* Đoạn dài của bản cũ chuyển thành tooltip, không in ra giữa trang. */
  const chuGiaiThich = giaiThich ?? description;

  return (
    <header className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0">
        <div className="flex min-w-0 items-center gap-2">
          <h1 className="truncate text-tieu-de-trang font-bold text-chu">{title}</h1>
          {chuGiaiThich && (
            <button
              type="button"
              // Nút chỉ có icon: phải có nhãn cho trình đọc màn hình.
              aria-label={`Giải thích: ${title}`}
              title={chuGiaiThich}
              className="inline-flex size-6 shrink-0 items-center justify-center rounded-full text-chu-phu hover:bg-neutral-nen hover:text-chu"
            >
              <HelpCircle size={16} aria-hidden="true" />
            </button>
          )}
        </div>
        {phu && <p className="mt-1 truncate text-phu text-chu-phu">{phu}</p>}
      </div>

      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
